// src/libs/algolia/createCachedRequester.ts
var createCachedRequester = (cachePrefix = "algolia") => {
  return {
    send: async (request) => {
      const { url, data, headers, method } = request;
      let cacheTags = [`${cachePrefix}-default`, `${cachePrefix}`];
      if (data) {
        try {
          const searchParams = JSON.parse(data);
          const params = searchParams.params || {};
          const filters = [];
          if (params.facetFilters) {
            const facetFilters = Array.isArray(params.facetFilters) ? params.facetFilters : [params.facetFilters];
            for (const filter of facetFilters) {
              if (typeof filter === "string") {
                if (filter.startsWith("year:")) {
                  filters.push(filter.replace("year:", "y"));
                } else if (filter.startsWith("month:")) {
                  filters.push(filter.replace("month:", "m"));
                } else if (filter.startsWith("category:")) {
                  filters.push(filter.replace("category:", "cat"));
                }
              } else if (Array.isArray(filter)) {
                for (const nestedFilter of filter) {
                  if (typeof nestedFilter === "string") {
                    if (nestedFilter.startsWith("year:")) {
                      filters.push(nestedFilter.replace("year:", "y"));
                    } else if (nestedFilter.startsWith("month:")) {
                      filters.push(nestedFilter.replace("month:", "m"));
                    } else if (nestedFilter.startsWith("category:")) {
                      filters.push(nestedFilter.replace("category:", "cat"));
                    }
                  }
                }
              }
            }
          }
          if (filters.length > 0) {
            cacheTags = [
              `${cachePrefix}-${filters.sort().join("-")}`,
              `${cachePrefix}`
            ];
          }
        } catch {
        }
      }
      const cacheConfig = {
        next: {
          tags: cacheTags
        }
      };
      try {
        const response = await fetch(url, {
          method: method || "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers
          },
          body: data,
          ...cacheConfig
        });
        const content = await response.text();
        return {
          content,
          status: response.status,
          isTimedOut: false
        };
      } catch (error) {
        return {
          content: JSON.stringify({ message: "Network request failed" }),
          status: 0,
          isTimedOut: true
        };
      }
    }
  };
};

export {
  createCachedRequester
};
